import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { ICategoryData } from '../../index';

export interface IGetAllCategoryRequestAction {
  data: {
    name?: string;
    page?: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function getAllRequest(
  draft: Draft<ICategoryData>,
  action: PayloadAction<IGetAllCategoryRequestAction>,
) {
  draft.getAll.config.errorMessage = '';
  draft.getAll.config.emptyMessage = '';
  draft.getAll.config.isLoading = true;
  draft.getAll.config.pagination.totalPages = 1;
  draft.getAll.config.pagination.page = action.payload.data.page;
  draft.getAll.list = [];
}

export default getAllRequest;
